export interface AppFeature {
  id: string;
  title: string;
  description: string;
  iconUrl: string;
}

export const APP_FEATURES: AppFeature[] = [
  {
    id: "conseillers",
    title: "150 conseillers à votre écoute",
    description: "Accédez à l'assistance Roole 7j/7, quand vous en avez besoin.",
    iconUrl: "/assets/pack-zero-franchise/assistance.svg",
  },
  {
    id: "declaration",
    title: "Déclaration possible via l'app",
    description: "Simple et rapide, vous déclarez en quelques clics depuis votre mobile.",
    iconUrl: "/assets/pack-zero-franchise/phone.svg",
  },
  {
    id: "suivi",
    title: "Suivi de sinistre en ligne",
    description: "Suivez l'avancée de votre dossier depuis votre mobile.",
    iconUrl: "/assets/pack-zero-franchise/car-tracking.svg",
  },
  {
    id: "virement",
    title: "Virement en quelques jours",
    description: "Les fonds arrivent directement sur votre compte.",
    iconUrl: "/assets/pack-zero-franchise/money-transfer.svg",
  },
];
